
export type GetPendingChatRequests200ItemCurrentUserStatusStatus = typeof GetPendingChatRequests200ItemCurrentUserStatusStatus[keyof typeof GetPendingChatRequests200ItemCurrentUserStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPendingChatRequests200ItemCurrentUserStatusStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
} as const;
